import { Col, Row } from "reactstrap";

interface Props {
    title: string
}

export const ContentHeading = (props: Props) => {
    return (
        <Row>
            <Col className="contentHeading">
                <h2 className="css_heading bold" dangerouslySetInnerHTML={{ __html: props.title }} />
            </Col>
        </Row>
    );
};